export default "__VITE_ASSET__8eb64be4__"